import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'views.PlannedEvents.title',
    defaultMessage: 'Planowane wydarzenia'
  },
  eventsButton: {
    id: 'views.PlannedEvents.events.button',
    defaultMessage: 'Więcej wydarzeń'
  }
});



// WEBPACK FOOTER //
// ./src/views/PlannedEvents/PlannedEvents.intl.js